import AriesIpcRouter, { type AriesIpcRouterType } from '@shared/ipc/routers/AriesIpc.router'
import {
  MicrophoneRequestOutcome,
  PermissionAssistantPanel,
  ScreenCaptureRequestOutcome,
  ScreenCaptureStatus,
  SystemAudioCaptureStatus,
  SystemAudioRequestOutcome,
  SystemSetting,
} from '@shared/types/Aries'

class AriesIpcRenderer extends AriesIpcRouter implements AriesIpcRouterType {
  async checkAccessibilityPerm(): Promise<boolean> {
    return this.exec('checkAccessibilityPerm')
  }

  async checkScreenCaptureStatus(): Promise<ScreenCaptureStatus> {
    return this.exec('checkScreenCaptureStatus')
  }

  async requestScreenCapturePerm(): Promise<ScreenCaptureRequestOutcome> {
    return this.exec('requestScreenCapturePerm')
  }

  async checkMicrophonePerm(): Promise<boolean> {
    return this.exec('checkMicrophonePerm')
  }

  async requestMicrophonePerm(): Promise<MicrophoneRequestOutcome> {
    return this.exec('requestMicrophonePerm')
  }

  async checkSystemAudioCapturePerm(): Promise<SystemAudioCaptureStatus> {
    return this.exec('checkSystemAudioCapturePerm')
  }

  async requestSystemAudioCapturePerm(): Promise<SystemAudioRequestOutcome> {
    return this.exec('requestSystemAudioCapturePerm')
  }

  async openSystemSettings(setting: SystemSetting): Promise<void> {
    return this.exec('openSystemSettings', setting)
  }

  async presentPermissionAssistant(panel: PermissionAssistantPanel): Promise<void> {
    return this.exec('presentPermissionAssistant', panel)
  }

  async dismissPermissionAssistant(): Promise<void> {
    return this.exec('dismissPermissionAssistant')
  }
}

export default new AriesIpcRenderer()
